/* eslint-disable @next/next/no-img-element */

import clsx from 'clsx';
// Atoms
import { useAtomValue } from 'jotai';

// Types
import type { Posts } from '@/components/pages/giveaway-picker/Types/types';

// Components
import Icon from '@/components/base/Icon';
import { socialProfileAtom } from '@/components/pages/giveaway-picker/Atoms/socialProfileAtom';
import { SelectedPostMask } from '@/components/pages/giveaway-picker/components/SelectedPostMask';

type PostImageProps = {
    post: Posts;
    summaryItem: boolean;
    selected?: boolean;
};

const getMediaTypeIcon = (mediaType: Posts['media_type']) => {
    switch (mediaType) {
        case 'reel':
            return 'reel';
        case 'carousel':
            return 'carousel';
        default:
            return null;
    }
};

export const PostImage = ({ post, summaryItem, selected }: PostImageProps) => {
    const selectedProfile = useAtomValue(socialProfileAtom);
    const mediaTypeIcon = getMediaTypeIcon(post.media_type);

    return (
        <div className="relative w-full overflow-hidden rounded-lg pb-[100%]">
            <img
                src={post.image}
                alt={selectedProfile.name[0]}
                className="absolute inset-0 h-full w-full rounded object-cover"
                data-testid="post-image"
            />
            {mediaTypeIcon ? (
                <span
                    className={clsx(
                        'absolute right-0 top-0 z-10 flex h-6 w-6 items-center justify-center rounded-bl-md bg-icoGray-100',
                        { 'bg-white': summaryItem }
                    )}
                    data-testid={`icon-${mediaTypeIcon}`}>
                    <Icon icon={mediaTypeIcon} className="text-xxs text-icoGray-500" />
                </span>
            ) : null}
            <SelectedPostMask selected={selected} />
        </div>
    );
};
